<template>
  <div :class="`app-${browser}`" id="app">
    <Heady/>
    <transition name="fade">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Heady from '@/layouts/Heady';

export default {
  name: 'app',
  computed: mapGetters({
    personIsAdmin: 'personIsAdmin',
    person: 'personCurrent',
    browser: 'browser',
  }),
  components: {
    Heady,
  },
  metaInfo: {
    title: 'Вкусомер',
  },
  mounted() {
    if (!this.person || !this.person.name) {
      this.$store.dispatch('fetchCurrentPerson');
    }
  },
};
</script>

<style>
@font-face {
  font-family: 'Story';
  src: url('/static/als-story-regular.eot'); /* IE9 Compat Modes */
  src: url('/static/als-story-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
  url('/static/als-story-regular.woff') format('woff'), /* Pretty Modern Browsers */
  url('/static/als-story-regular.ttf')  format('truetype'), /* Safari, Android, iOS */
  url('/static/als-story-regular.svg#svgFontName') format('svg'); /* Legacy iOS */
}

@font-face {
  font-family: 'Flai';
  src: url('/static/hinted-ALSFlai.eot'); /* IE9 Compat Modes */
  src: url('/static/hinted-ALSFlai.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
  url('/static/hinted-ALSFlai.woff') format('woff'), /* Pretty Modern Browsers */
  url('/static/hinted-ALSFlai.ttf')  format('truetype'), /* Safari, Android, iOS */
  url('/static/hinted-ALSFlai.svg#svgFontName') format('svg'); /* Legacy iOS */
}

body{
  font-family: 'Story', sans-serif;
  font-size: 16px;
  min-width: 320px;
  color: black;
  padding: 0;
  margin: 0;
}

h1{
  font-size: 260%;
}

h2{
  margin-top: 18px;
  margin-bottom: 20px;
  @media (max-width: $mediaMob){
    margin-top: 28px;
    font-size: 130%;
  }
  @media (max-width: $mediaIphone5) {
    margin-top: 30px;
    font-size: 100%;
  }
}

h3{
  letter-spacing: .045em;
  line-height: 1.5;
  font-weight: 300;
}

h4{
  font-size: 140%;
}

a{
  transition: color .15s ease-in-out;
  text-decoration: none !important;
  color: #000000;
  border-bottom: solid 1px rgba(0,0,0,.3);

  &:hover{
    text-decoration: none;
    color: #d04444 !important;
    border-color: rgba(208,68,68,.3) !important;
  }
}

a.white{
  transition: color, opacity .15s ease-in-out;
  border-bottom-color: rgba(255,255,255,.3);
  color: white;

  &:hover{
    opacity: .7;
  }
}

textarea{
  border: dashed 1px gray;
  padding: 30px 40px;
  display: block;
  margin: 0 auto;

  max-width: 600px;
  font-size: 250%;
  width: 100%;
}

select,
textarea,
input{
  font-weight: lighter;
  font-size: 120%;
}

select,
textarea,
button,
input{
  outline: 0;
}

select,
input{
  border: 0;
  border-bottom: solid 2px rgba(128, 128, 128, 0.4);
  padding: 4px 8px;
  width: 110px;

}

[type='submit']{
  transition: all .3s ease-in-out;
  background: #04cc99;
  color: white;
  border: 0;
  border-radius: 4px;
  padding: 5px;

  &:hover{
    background: #56cc04;
  }
}

select{
  position: relative;
  font-size: 150%;
  cursor: pointer;
  width: 130px;
  top: 7px;
}

dt{
  margin: 40px 0;
}

button{
  transition: opacity, background .3s ease-in-out;
  background: #fa9920;
  border-radius: 25px;
  padding: 26px 35px 24px;
  font-weight: 300;
  font-size: 120%;
  display: block;
  line-height: 0;
  color: white;
  border: 0;

  &:hover{
    background: #56cc04;
  }
}

::-webkit-input-placeholder {font-weight: 300;}
::-moz-placeholder          {font-weight: 300;}
:-moz-placeholder           {font-weight: 300;}
:-ms-input-placeholder      {font-weight: 300;}

.router-link-exact-active{
  cursor: text;
}


.fade-enter-active,
.fade-leave-active {
  transition-property: opacity, transform;
  transition-duration: .5s;
}

.fade-enter-active {
  transition-property: opacity;
  transition-delay: .5s;
}

.fade-enter,
.fade-leave-active {
  /*transform: scale(.97);*/
  opacity: 0
}

.overflow-y{
  overflow-y: scroll;
}

@keyframes greet{
  from{
    opacity: 0;
  }
  to{
    opacity: 1;
  }
}
.greet{
  display: none;

  &-active{
    animation: greet .3s ease-in-out;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?5a6410f6